import React from 'react'

import clsx from 'clsx'

import { BaseButton } from 'components/Button'
import Logo from 'components/Logo'
import Review from 'components/Review'

import classes from './MiniCard.module.scss'

/** @type {import("./types").default} */
const MiniCard = ({ listing = {}, href, className, ...extraProps }) => {
  return (
    <BaseButton
      component={href ? 'a' : 'div'}
      className={clsx('MiniCard', classes.root, className)}
      href={href}
      {...extraProps}
    >
      <Logo className={classes.logo} src={listing.logo_url} alt={`${listing.name} logo`} size={40} />
      <div className={classes.content}>
        <p className={classes.title}>{listing.name}</p>
        <Review.Rating rating={listing.rating_avg || listing.rating} withRatingNum xs />
      </div>
    </BaseButton>
  )
}

export default MiniCard
